import { render, staticRenderFns } from "./ElementOverviewElementSupport.vue?vue&type=template&id=41250b81&scoped=true&"
import script from "./ElementOverviewElementSupport.vue?vue&type=script&lang=js&"
export * from "./ElementOverviewElementSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41250b81",
  null
  
)

export default component.exports